// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"f2d18810","365":"b53e2836","531":"cee1ccb5","555":"f04866ea","809":"f069be06","955":"752aecc5"}[chunkId] + ".chunk.js";
};